import { statusVistoriaConfig } from "@/mocks/vistorias";

interface InspectionStatusBadgeProps {
  status: string;
}

export default function InspectionStatusBadge({ status }: InspectionStatusBadgeProps) {
  const config = statusVistoriaConfig[status] || { badge: "bg-background-100 text-foreground-500", label: status };
  return (
    <span className={`badge ${config.badge}`}>
      {status === "Vencida" && <i className="ri-error-warning-line mr-1 text-xs"></i>}
      {config.label}
    </span>
  );
}